module.exports = __webpack_public_path__ + "img/building95-2.8ac386c1.jpg";